export default "__VITE_ASSET__p8T0rcRH__"